import styled, { css } from 'styled-components';

export const paragraphStyles = css`
	margin-bottom: 1.5rem;
	line-height: 2.8rem;
	font-size: 1.8rem;
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	color: ${({ theme }) => theme.colors.textColor};
`;

export const P = styled.p`
	${paragraphStyles};
	margin-top: ${({ marginTop }) => marginTop || '0'};

	${({ white, theme }) =>
		white &&
		css`
			color: ${theme.colors.white};
		`}

	${({ black, theme }) =>
		black &&
		css`
			color: ${theme.colors.black};
		`}

	${({ subtitle, theme }) =>
		subtitle &&
		css`
			font-size: 2rem;
			line-height: 3rem;
			color: ${theme.colors.grayDarker};
		`}

	${({ small }) =>
		small &&
		css`
			font-size: 1.6rem;
			line-height: 2.6rem;
		`}
`;

export const strongStyles = css`
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
	color: ${({ theme }) => theme.colors.textDark};
`;

export const Strong = styled.strong`
	${strongStyles};
`;
